import Dexie, { type Table } from 'dexie';
import { SymptomEntry, StoredAnalysis, KBDocument, KBChunk } from '../types';

export interface PreferencesRow {
  id: 'singleton';
  demoMode: boolean;
  notificationsEnabled: boolean;
}

export class SymptomTrackerDB extends Dexie {
  entries!: Table<SymptomEntry, string>;
  analyses!: Table<StoredAnalysis & { id?: number }, number>;
  preferences!: Table<PreferencesRow, string>;
  kbDocs!: Table<KBDocument, string>;
  kbChunks!: Table<KBChunk, string>;

  constructor() {
    super('symptom-tracker-db');

    this.version(1).stores({
      entries: 'date',
      analyses: '++id, date',
      preferences: 'id',
      kbDocs: 'id',
      kbChunks: 'id, docId'
    });
  }
}

export const db = new SymptomTrackerDB();
